import { Component, DestroyRef, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { UserRegisterForm } from '../../../../_forms/user-register.form';
import { AuthService } from '../../../../_services/auth.service';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-register',
  imports: [ReactiveFormsModule, ButtonComponent, RouterModule, NgIf],
  templateUrl: './register.component.html',
  styleUrl: './register.component.css',
  standalone: true,
})
export class RegisterComponent {
  form = new UserRegisterForm();
  loading = false;
  errorMessage = '';
  isIncubator = signal(false);

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly destroyRef: DestroyRef
  ) {}

  onIncubatorToggle(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.isIncubator.set(checked);
  }

  submit() {
    if (this.form.invalid || this.loading) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading = true;

    const userData = { ...this.form.value, isIncubator: this.isIncubator() };
    //console.log(userData)

    if (this.isIncubator()) {
      this.router.navigate(['/auth/register-incubator'], { queryParams: userData });
      this.loading = false;
    } else {
      this.auth
        .register(userData)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (res:any) => {
            this.loading = false;
            const email = this.form.value.email;

            //provisorio
            if(res.passwordToken) {
              const token = res.passwordToken;
              this.router.navigate(['/auth/email-confirmed'], { queryParams: { token } });
              return;
            }
            this.router.navigate(['/auth/check-email'], { state: { email } });
          },
          error: (err) => {
            this.loading = false;
            this.errorMessage = err.error?.message || 'Registration failed. Please try again.';
          },
        });
    }
  }
}
